<div class="tab-container">
	<!-- Tab Headers -->
	<div class="tab-headers">
		<button *ngFor="let tab of tabs; let i = index"
				class="tab-header"
				[class.active]="i === selectedIndex"
				(click)="onTabClick(i)"
				[attr.aria-selected]="i === selectedIndex"
				role="tab">
			{{ tab.label }}
		</button>
	</div>

	<!-- Tab Content -->
	<div class="tab-content">
		<ng-content></ng-content>
	</div>
</div>
